import React, { useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import { createGlobalStyle } from 'styled-components';
import 'primeicons/primeicons.css';
import RainParameter from './ContractParameter/rainParameter';
import CollectionPoolParameter from './ContractParameter/collectionPoolParameter';
import IliParameter from './ContractParameter/iliParameter';
import ScoringGridParameter from './ContractParameter/ScoringGridParameter';
import { renderSwitchButtons } from '../utils/helpers/view/detailsHelper';
import { TabProps } from '../utils/Interface';
import ResetStyleComponent from '../components/cssSaur/resetStyleComponent';

const ContractParameterView = () => {
  const sessionCode = window.sessionStorage.getItem('contractCode')!;
  const sessionId = window.sessionStorage.getItem('contractId')!;

  // Gestion des onglets avec un seul state
  const [tabsStates, setTabsStates] = useState<TabProps[]>([
    { id: 0, label: 'Pluviométrie', active: true },
    { id: 1, label: 'Bassin de collecte', active: false },
    { id: 2, label: 'ILI', active: false },
    { id: 3, label: 'H2S', active: false },
  ]);

  return (
    <Container className='sds-reset-style parameterClass'>
      <ResetStyleComponent />
      <Styles />
      {/* titre de l'onglet */}
      <Container className='ecp-title'>
        <Word
          variant='p'
          textStyle='title'
          value='PARAMETRAGE DU CONTRAT'
          className='page-title'
        />
      </Container>
      <div className='contractFilters'>
      {renderSwitchButtons(tabsStates, setTabsStates)}
      </div>
      <Container style={{ display: tabsStates[0].active ? 'block' : 'none' }}>
        <RainParameter contractId={sessionId} />
      </Container>
      <Container style={{ display: tabsStates[1].active ? 'block' : 'none' }}>
        <CollectionPoolParameter contractCode={sessionCode} />
      </Container>
      <Container style={{ display: tabsStates[2].active ? 'block' : 'none' }}>
        <IliParameter contractId={sessionId} />
      </Container>
      <Container style={{ display: tabsStates[3].active ? 'block' : 'none' }}>
        <ScoringGridParameter contractId={sessionId} />
      </Container>
    </Container>
  );
};
const Styles = createGlobalStyle`
  .contractFilters .sds-word.normalBold{
    width: 20vh;
  }
  .rain-global-container.sds-reset-style .rainContainer{
    width: 100vh;
  }
  .ecp-global-container.sds-reset-style .ecpContainer .ecpContent{
    width: 80vw;
  }
  .parameterClass{
    margin-left: 37vh;
    margin-right: 2%;
    margin-bottom: 2%;
    width:80%;
    .hide-vue-pluie, .hide-vue-ecp, .hide-vue-ili, .hide-vue-scoring-grid{
      display: none;
    }
    .vue-scoring-grid{
      align-items : center;
    }
    .ecp-title{
      padding-top: 32px;
      margin-bottom: 2%;
      .page-title{
        font-weight: bold;
      }
    }
  }
  .ecp-title{
    margin-bottom: 2%;
  }
  .sds-container.card{
    border:0px;
  }
  .ecp-filtre{
    .FilterSelect{
      width:50%;
      align-self:start;
      margin-bottom: 15px;
      .filter-animate-content{
        background-color: #008BD2
      }
      .filter-button{
        background-color: #F5F8FB;
      }
    }
  }
`;
export default ContractParameterView;
